import styled from 'styled-components'
import theme from 'styles/theme'
import { getBGColor } from 'utils/themeUtils'

export const PDFListWrapper = styled.div`
  background: ${getBGColor()};
  color: ${theme.colors.sagedark};
  margin: 0 auto;
  padding: 0;
  text-align: center;

  ${theme.mediaQueries.medium} {
    margin: 0 auto;
    max-width: 1180px;
  }
`

export const PDFListItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 980px;
  margin: auto 40px;
  width: auto;

  ${theme.mediaQueries.medium} {
    margin: auto;
  }
`

export const PDFListItem = styled.a`
  ${theme.textStyles.body12Uppercase}
  margin: auto;

  border-bottom: 1px solid ${theme.colors.sagelight};
  display: block;
  p {
    margin: 0;
  }

  padding: ${theme.space[4]} 0;
  width: 100%;

  &:last-of-type {
    border-bottom: 0;
  }

  &:nth-last-child(2):nth-child(odd) {
    border-bottom: 1px solid ${theme.colors.sagelight};

    ${theme.mediaQueries.medium} {
      border-bottom: 0;
    }
  }

  ${theme.mediaQueries.medium} {
    width: calc(50% - 10px);
  }
`
